import { useSyncExternalStore } from 'react';
import { getViewContext, subscribeToViewContext, type ViewContext } from '../../core/services/viewContext';

/** Live subscription to the app-wide current-context event bus (see core/services/viewContext). */
export function useViewContext(): ViewContext {
  return useSyncExternalStore(subscribeToViewContext, getViewContext);
}
